exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".tags-bar {\n  display: inline-block;\n  text-align: center;\n  margin: 0 auto; }\n", ""]);

// exports
